import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import CosmicBackground from "./CosmicBackground";

const COLORS = ["#FF2D5C", "#FF3DCB", "#9B4DFF", "#3DBFFF", "#6FF6FF"];

const Biologisk = () => {
  const { t } = useTranslation();
  const items = t("biologi.items", { returnObjects: true });

  return (
    <section
      id="biologi"
      data-testid="biologi-section"
      className="relative section-pad overflow-hidden"
    >
      <CosmicBackground variant="intense" />

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mx-auto max-w-3xl text-center">
          <span className="eyebrow">{t("biologi.eyebrow")}</span>
          <h2 className="font-display mt-5 text-xl sm:text-[1.5rem] lg:text-[1.75rem] font-semibold leading-[1.18] text-white glow-text-white uppercase tracking-[-0.005em]">
            {t("biologi.title")}
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/70 leading-relaxed">
            {t("biologi.lead")}
          </p>
        </div>

        {/* Substance grid */}
        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {Array.isArray(items) &&
            items.map((item, i) => {
              const color = COLORS[i % COLORS.length];
              return (
                <motion.div
                  key={i}
                  data-testid={`biologi-item-${i}`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  className="group relative flex flex-col overflow-hidden rounded-2xl glass p-6 electric-border min-h-[260px]"
                >
                  {/* Big nucleus */}
                  <div
                    className="absolute -right-16 -top-16 h-48 w-48 rounded-full opacity-50 blur-3xl transition-opacity duration-500 group-hover:opacity-80"
                    style={{ background: color }}
                  />

                  <div className="relative flex h-16 w-16 items-center justify-center rounded-full">
                    <span
                      className="absolute inset-0 rounded-full opacity-70 blur-md"
                      style={{ background: color }}
                    />
                    <span
                      className="relative h-3.5 w-3.5 rounded-full bg-white shadow-[0_0_18px_rgba(255,255,255,0.9)]"
                    />
                  </div>

                  <span
                    className="font-mono mt-5 text-[10px] uppercase tracking-[0.24em]"
                    style={{ color }}
                  >
                    {t("biologi.signal_label")} · 0{i + 1}
                  </span>
                  <h3
                    className="font-display relative mt-2 text-2xl font-bold"
                    style={{ color, textShadow: `0 0 14px ${color}99, 0 0 28px ${color}55` }}
                  >
                    {item.name}
                  </h3>
                  <p className="relative mt-3 text-sm leading-relaxed text-white/70">
                    {item.desc}
                  </p>
                </motion.div>
              );
            })}
        </div>

        <p className="mt-14 text-center font-display text-lg md:text-2xl text-white/85 italic">
          “{t("biologi.footer")}”
        </p>
      </div>
    </section>
  );
};

export default Biologisk;
